// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"df06cbc8","627":"6fb8a6f6","738":"b03ed346","923":"426805bb"}[chunkId] + ".chunk.js";
};